import React, { Fragment } from 'react'
import Header from './Header';
import { Box } from '@mui/material';
import SideNav from './SideNav';
import { Outlet } from 'react-router-dom';

export const Layout = ({ children }) => {
  return (
    <Fragment>

      {/* ========== Header ========== */}

      <Header />

      <Box sx={{ display: "flex" }}>

        {/* ========== SideNav ========== */}
        <Box>
          <SideNav />
        </Box>

        <Box
  sx={{
    mx: "auto", // centers the box horizontally
    flexGrow: 1,
    width: {
      xs: "95%",
      sm: "90%",
      md: "70%",
      lg: "75%",
      xl: "70%",
    },
    // maxWidth: "1600px", 
    transition: "width 0.3s ease-in-out", 
  }}
>
  <Outlet />
</Box>

      </Box>

    </Fragment>
  )
}
